module.exports = __webpack_public_path__ + "static/img/13.be6f6e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/eng/13.png
// module id = igBb
// module chunks = 0